/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Machine_Id_LabelInputs */



/**
* | output |
* | --- |
* | "Machine Id" |
*
* @param {Offline_Activation_Machine_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_machine_id_label = /** @type {((inputs?: Offline_Activation_Machine_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Machine_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identifiant machine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maschinen-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID macchina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор машины")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación de la máquina")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("机器 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マシンID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मशीन आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID da máquina")
	return /** @type {LocalizedString} */ ("Machine Id")
});